// extracted by mini-css-extract-plugin
export default {"input-custom":"styles_input-custom__bVjTS","lable-style":"styles_lable-style__z4RIA"};